var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9157 9.95531H15.2284V12.1769H15.2895C15.8921 11.0995 17.3584 9.95531 19.5495 9.95531C24.1011 9.95531 24.9425 12.7879 24.9425 16.473V24.2654H20.4465V17.3395C20.4465 15.7538 20.4131 13.7126 18.1082 13.7126C15.8033 13.7126 15.4089 15.4372 15.4089 17.2256V24.2793H10.9157V9.95531ZM8.36355 5.61757C8.36355 6.08003 8.22642 6.53211 7.96948 6.91664C7.71255 7.30117 7.34736 7.60087 6.9201 7.77785C6.49284 7.95483 6.02269 8.00113 5.56911 7.91091C5.11553 7.82069 4.69889 7.59799 4.37188 7.27097C4.04486 6.94396 3.82216 6.52732 3.73194 6.07374C3.64172 5.62016 3.68802 5.15001 3.865 4.72275C4.04198 4.29549 4.34168 3.9303 4.72621 3.67337C5.11074 3.41643 5.56282 3.2793 6.02528 3.2793C6.64521 3.28003 7.23953 3.52662 7.67788 3.96497C8.11623 4.40332 8.36282 4.99765 8.36355 5.61757ZM3.69257 9.95531H8.36355V24.2654H3.69257V9.95531Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlackIcon);
export default __webpack_public_path__ + "static/media/LinkedIn_black_icon.17439b641a4da94bbc41cd8bd677dc14.svg";
export { ForwardRef as ReactComponent };